/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S5_P2Inputs */

const en_guide_json_schema_s5_p2 = /** @type {(inputs: Guide_Json_Schema_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can use PureJSON's <a href="/json-to-typescript">JSON to TypeScript</a> converter to generate TypeScript interfaces from your data, and JSON Schema for runtime validation: they complement each other.`)
};

const ko_guide_json_schema_s5_p2 = /** @type {(inputs: Guide_Json_Schema_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON의 <a href="/json-to-typescript">JSON to TypeScript</a> 변환기로 데이터에서 TypeScript 인터페이스를 생성하고, 런타임 유효성 검사에는 JSON Schema를 사용하세요: 서로 보완적입니다.`)
};

const ja_guide_json_schema_s5_p2 = /** @type {(inputs: Guide_Json_Schema_S5_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONの<a href="/json-to-typescript">JSON to TypeScript</a>変換ツールを使用してデータからTypeScriptインターフェースを生成し、ランタイムバリデーションにはJSON Schemaを使用できます: 両者は補完的な関係にあります。`)
};

/**
* | output |
* | --- |
* | "You can use PureJSON's <a href=\"/json-to-typescript\">JSON to TypeScript</a> converter to generate TypeScript interfaces from your data, and JSON Schema for r..." |
*
* @param {Guide_Json_Schema_S5_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s5_p2 = /** @type {((inputs?: Guide_Json_Schema_S5_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S5_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s5_p2(inputs)
	if (locale === "ko") return ko_guide_json_schema_s5_p2(inputs)
	return ja_guide_json_schema_s5_p2(inputs)
});